export default "__VITE_ASSET__CG06cHD8__"